import { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Title } from './helper/DocumentTitle'
import roadMap from './../images/road-map.png'
import styles from '../styles/module/Passage.module.scss'

export default function Passage({ title }) {
    Title(title)
    const param = useParams()

    useEffect(() => {
        document.querySelector('header span').innerText = title
    }, [])

    if (param.requestType == 'submit') return <iframe src={`https://137.ardabilcity.ir/RequestCitizen.aspx`} />

    if (param.requestType == 'tracking') return <iframe src={`https://137.ardabilcity.ir/FollowUpCitizen.aspx`} />
    return <section className={styles.platform137}>
          <Link to={`../`} className='btn btn-back-top'>بازگشت</Link>
        <div className='__frame' data-width={`large`}>
            
            <h3>{title}</h3>
            <p>برای ادامه لطفا نوع عملیات را مشخص کنید</p>

            <div className='grid grid--fit grid--gap-1' style={{ '--data-width': '300px'}}>
                <Link to={`./new`}>
                    <div className={styles.gridItem}>
                        <div className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M450-200v-250H200v-60h250v-250h60v250h250v60H510v250h-60Z" /></svg>
                        </div>
                        <h4>درخواست جدید</h4>
                    </div>
                </Link>
                
                <Link to={`./list`}>
                    <div className={styles.gridItem}>
                        <div className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M377-198v-60h463v60H377Zm0-252v-60h463v60H377Zm0-253v-60h463v60H377ZM189-161q-28.05 0-48.025-19Q121-199 121-227.5t19.5-48q19.5-19.5 48-19.5t47.5 19.975Q255-255.05 255-227q0 27.225-19.387 46.613Q216.225-161 189-161Zm0-252q-28.05 0-48.025-19.681Q121-452.362 121-480t19.975-47.319Q160.95-547 189-547q27.225 0 46.613 19.681Q255-507.638 255-480t-19.387 47.319Q216.225-413 189-413Zm-1-253q-27.637 0-47.319-19.681Q121-705.362 121-733t19.681-47.319Q160.363-800 188-800q27.637 0 47.319 19.681Q255-760.638 255-733t-19.681 47.319Q215.637-666 188-666Z" /></svg>
                        </div>
                        <h4>درخواست های من</h4>
                    </div>
                </Link>
            </div>

            <figure>
                <img src={roadMap}  style={{width:'100%'}}/>
            </figure>
        </div>
        <Link to={`../`} className='btn btn-back-bottom'>بازگشت</Link>
    </section>
}